<div class="card-linked-single" id="">
  <div class="card-linked-action-icon">
    <span (click)="deleteCard = !deleteCard" class="material-icons">more_horiz</span>
  </div>
  <div class="card-linked-single-footer">
    <p class="card-number">{{ linkedCard!.CardNumber | creditCardNumber }}</p>
    <ng-container [ngSwitch]="linkedCard!.CardType">
      <img class="payment-logo" *ngSwitchCase="1" [src]="'payment-icons/mastercard.svg' | contentAssetImage" />
      <img class="payment-logo" *ngSwitchCase="2" [src]="'payment-icons/amex.svg' | contentAssetImage" />
      <img class="payment-logo" *ngSwitchCase="3" [src]="'payment-icons/visa.svg' | contentAssetImage" />
      <img class="payment-logo" *ngSwitchCase="4" [src]="'payment-icons/discover.svg' | contentAssetImage" />
      <img class="payment-logo" *ngSwitchCase="5" [src]="'payment-icons/jcb.svg' | contentAssetImage" />
      <img class="payment-logo" *ngSwitchCase="8" [src]="'payment-icons/unionpay.svg' | contentAssetImage" />
      <div class="payment-logo" *ngSwitchDefault></div>
    </ng-container>
  </div>
  <button
    *ngIf="deleteCard"
    (click)="externalCardId = linkedCard!.ExternalCardId; openModel(content)"
    class="card-linked-delete-button"
  >
    <span class="material-icons">delete</span> {{ 'fgbcl.card.linking.delete.card.label' | translate }}
  </button>
</div>

<ng-template #content let-modal>
  <div class="modal-body text-center d-flex align-items-center justify-content-center">
    <span class="material-icons confim-model-delete-icon">delete</span>
    <p class="confim-model-delete-title">{{ 'fgbcl.card.linking.delete.card.model.title' | translate }}</p>
  </div>
  <div class="modal-footer justify-content-center">
    <p class="confirmation-text">{{ 'fgbcl.card.linking.delete.card.model.description' | translate }}</p>
    <div>
      <button type="button" class="btn btn-danger me-3" (click)="cancel()">
        {{ 'fgbcl.card.linking.delete.card.model.cancel.button.text' | translate }}
      </button>
      <button type="button" class="btn btn-success" (click)="deleteLinkedCard()">
        {{ 'fgbcl.card.linking.delete.card.model.confirm.button.text' | translate }}
      </button>
    </div>
  </div>
</ng-template>
